// collection-toggle.js
document.addEventListener('DOMContentLoaded', function() {
    // Find the element we want to insert our toggle buttons before
    // Most Shopify Dawn themes have a product count element we can target
    const productCountSection = document.querySelector('.product-count');
    
    if (!productCountSection) {
      console.warn('Product count section not found');
      return;
    }
    
    // Create our toggle buttons
    const toggleButtons = document.createElement('div');
    toggleButtons.className = 'view-toggle-container';
    toggleButtons.innerHTML = `
      <div class="view-toggle-buttons">
        <button type="button" class="view-toggle-btn grid-view" aria-label="Grid view">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
          </svg>
        </button>
        <button type="button" class="view-toggle-btn list-view active" aria-label="List view">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
        </button>
      </div>
    `;

    productCountSection.parentNode.insertBefore(toggleButtons, productCountSection);
    
    // Get references to our buttons and the product view div
    const gridViewBtn = toggleButtons.querySelector('.grid-view');
    const listViewBtn = toggleButtons.querySelector('.list-view');
    const productView = document.querySelector('.product-view');
    
    if (!productView) {
      console.warn('Product view container not found');
      return;
    }
    
    // Add click handlers for grid view
    gridViewBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Update button states
      gridViewBtn.classList.add('active');
      listViewBtn.classList.remove('active');
      
      productView.id = 'product-grid-view';
      
      document.body.classList.remove('list-view-active');
      document.body.classList.add('grid-view-active');
      
      localStorage.setItem('view-preference', 'grid');
      
      return false;
    });
    
    listViewBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      listViewBtn.classList.add('active');
      gridViewBtn.classList.remove('active');
      productView.id = 'product-list-view';
      
      document.body.classList.remove('grid-view-active');
      document.body.classList.add('list-view-active');
      localStorage.setItem('view-preference', 'list');
      
      return false;
    });
    const savedView = localStorage.getItem('view-preference');
    if (savedView === 'list') {
      // Apply list view styles without clicking the button
      listViewBtn.classList.add('active');
      gridViewBtn.classList.remove('active');
      productView.id = 'product-list-view';
      document.body.classList.remove('grid-view-active');
      document.body.classList.add('list-view-active');
    }
    
    console.log('View toggle buttons successfully initialized');
  });

document.addEventListener('DOMContentLoaded', () => {
  // Delegate one listener for all Parts-Index links
  document.querySelectorAll('.product-collection_2__listitem').forEach(li => {
    const link = li.querySelector('a');
    // pull the handle from the <li>’s data-handle (or parse from href)
    const handle = li.dataset.handle 
                 || link.getAttribute('href').replace('#item-','');
    li.dataset.handle = handle;

    link.addEventListener('click', e => {
      e.preventDefault();

      // 1) Clear all .active
      document.querySelectorAll(
        '.product-collection_2__listitem.active, .grid__item.active, .schematic-dot.active'
      ).forEach(el => el.classList.remove('active'));

      // 2) Add .active to list row, dot(s), and grid card
      document.querySelectorAll(`[data-handle="${handle}"]`)
              .forEach(el => el.classList.add('active'));

      // 3) Scroll the grid card into view
      const card = document.querySelector(`.grid__item[data-handle="${handle}"]`);
      if (card) {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
});
